/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineRecipe } from '@chakra-ui/react';

export const checkmark = defineRecipe({
  className: 'chakra-checkmark',
  base: {
    _icon: {
      boxSize: 'full',
      '&:is([data-state=checked], [data-state=indeterminate])': {
        strokeWidth: '1px',
      },
    },

    border: '1px solid gray.200',

    background: 'gray.25',
    _hover: {
      borderColor: 'blue.500',
      _disabled: {
        borderColor: 'on-navy.200',
      },
    },
    _disabled: {
      borderColor: 'on-navy.200',
      _checked: {
        borderColor: 'on-navy.200',
      },
    },
  },
  variants: {
    size: {
      xs: {
        boxSize: '3',
      },
      sm: {
        boxSize: '4',
      },
      md: {
        boxSize: '5',
        p: '0.5',
      },
      lg: {
        boxSize: '6',
        p: '0.5',
      },
    },
    variant: {
      solid: {
        _dark: {
          borderColor: 'gray.400',
          bg: 'white',
          '&:is([data-state=checked], [data-state=indeterminate])': {
            bg: 'link',
            color: 'colorPalette.contrast',
            borderColor: 'link',
          },
          _disabled: {
            borderColor: 'border',
            bg: 'border',
          },
        },
      },
    },
  },

  defaultVariants: {
    size: 'lg',
  },
});
